import useSWR from "swr";
import { URLS } from "../../Services/Urls";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { loginSuccess } from "../../Redux/Store/Slices/Auth";
import { getUserDetails, ls, setUserDetails } from "../Utils/Functions";
import { API } from "../../Services/axios";


const Auth = (props) => {
    
  const userDetails = getUserDetails();
  const dispatch = useDispatch();

  useEffect(() => {
      if(userDetails){
          API.get(URLS.AUTHS.me).then((resp) => {
              dispatch(loginSuccess({...userDetails, user: resp.data}))
              setUserDetails({...userDetails, user: resp.data})
          }).catch((error) => {
              dispatch(loginSuccess({...userDetails}))
          })
      }
  }, );                                                                                                     

  return <div></div>;
}

export default Auth